import { get } from './api';
import { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

export const getTicketRequestCategories = async (roofTopId?: string) => {
  const response = await get<TicketRequestCategoryI[]>(`/ticket-request-categories`, { roofTopId });

  return response.data;
};
